import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer'
import resipro from '../../assets/images/resiproIcon.svg'
// import Iframe from 'react-iframe'

function MobileFoodOrder() {
  // https://harshuveg.com/

  // const url = "https://www.google.co.in";
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        <MobileDrawer />
        <div className="EventTimeView">
          <img src={resipro} className="HeaderlogoImage" alt='altimg'/>
          <h2 className="mobHeadHeading">Park Side Apartment</h2>
        </div>
    </div>
    <div className='topSpace'></div>
      <div style={{display:'flex', flex:1}}>
      {/* <Iframe url={url}
          height='300px'
          width='100%'
          display="block"
          position="absolute"
          frameborder="0"
          allowfullscreen
          target="_parent"
        /> */}
      </div>
    </div>
  )
}

export default MobileFoodOrder